
<template>
    
        <mars-view><c-popup :show="true" class="question-desc-popup" @close="closePopupFn"><mars-view :show="true" class="question-desc-popup-box"><mars-view class="main-content-box"><mars-view class="title">问题描述</mars-view><mars-view class="close-box" @click.native="handleClose"><mars-view class="close"></mars-view></mars-view><mars-view class="textarea-container"><mars-textarea class="textarea-box" style="height: 0.8rem;" rows="6" :auto-focus="true" :disabled="disable" :value="contentQuery" :maxlength="500" :adjust-position="false" placeholder="请详细描述您的问题,便于律师给出专业解答" placeholder-style="font-size: 0.16rem" @input="textChange" @blur="inputBlur" @confirm="onConfirm"></mars-textarea><mars-view class="words-number"><mars-view v-if="contentQuery.length < 10">
                            最少还需描述<mars-text class="number">{{ 10 - contentQuery.length }}</mars-text>字
                        </mars-view><mars-view v-else>
                            {{ contentQuery.length }}/{{ 500 }}
                        </mars-view></mars-view></mars-view><mars-view class="watch-example" @click.native="handleCheck('showTipPopup')">
                    查看提问示例
                </mars-view></mars-view></mars-view></c-popup><c-popup v-if="showTipPopup" class="tip-popup" :show="showTipPopup" @close="handleCheck('showTipPopup')"><mars-view class="experthome-popup"><mars-view class="experthome-popup-title"><mars-text>法律问题怎么提？</mars-text><mars-view class="l-span-right"><mars-view class="icon iconfont experthome-popup-close" @click.native.stop="handleCheck('showTipPopup')">
                        
                    </mars-view></mars-view></mars-view><mars-view class="question-tip-content"><chat-tip-popup></chat-tip-popup></mars-view></mars-view></c-popup></mars-view>
    
</template>

<script>
import Popup from "../../components/common/newPopup.vue";
import chatPopup from "../chat/chatPopup.vue";
export default {
  components: {
    'c-popup': Popup,
    'chat-tip-popup': chatPopup
  },
  props: {
    oriContent: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentQuery() {
      return this.consultContent || this.oriContent;
    }
  },
  data() {
    return {
      showPopup: false,
      showTipPopup: false,
      // 展示示例弹窗
      questionDesc: '',
      consultContent: ''
    };
  },
  methods: {
    /**
     * 切换弹窗的显示状态
     * @param {checkName} string 弹窗分类名称
     * @return {void}
     */

    handleCheck(checkName) {
      this[checkName] = !this[checkName];
    },
    /**
     * 弹窗关闭
     */

    handleClose() {
      this.$emit('close');
    },
    /**
     * 问题输入框输入文本事件
     * @param {event} object input事件回调参数
     * @return {void}
     */

    textChange(event) {
      this.consultContent = event.detail.value;
      this.$emit('textInput', event);
    },
    /**
     * 输入框失去焦点，避免页面留白（兼容ios h5）
     * @return {void}
     */

    inputBlur() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    },
    /**
     * 点击确认
     */

    onConfirm(event) {
      this.$emit('onConfirm', event);
    }
  }
};
</script>

<style scoped>
.question-desc-popup .question-desc-popup-box {
  height: 70vh;
  position: relative;
  padding: 4.11vw 4.11vw 4.59vw;
  background-color: #fff;
  border-radius: 5.07vw 5.07vw 0 0;
  box-sizing: border-box;
}
.question-desc-popup .question-desc-popup-box .title {
  font-family: PingFangSC-Medium;
  font-size: 4.35vw;
  text-align: center;
  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 4.35vw;
  font-weight: 500;
}
.question-desc-popup .question-desc-popup-box .close-box {
  position: absolute;
  z-index: 1;
  width: 7.14vw;
  height: 7.14vw;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 2.83vw;
  right: 2.11vw;
}
.question-desc-popup .question-desc-popup-box .close {
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.question-desc-popup .question-desc-popup-box .textarea-container {
  position: relative;
  margin-top: 6.6vw;
}
.question-desc-popup .question-desc-popup-box .textarea-container .textarea-box {
  width: 100%;
  padding: 0.13rem;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #1e1f24;
  letter-spacing: 0;
  text-align: justify;
  line-height: 5.56vw;
  font-weight: 400;
  border: 0.16vw solid #b8b8b8;
  border-radius: 2.17vw;
  box-sizing: border-box;
  background-color: #fff;
  outline: none;
}
.question-desc-popup .question-desc-popup-box .textarea-container .textarea-placeholder {
  line-height: 5.56vw;
  color: #858585;
}
.question-desc-popup .question-desc-popup-box .textarea-container .words-number {
  position: absolute;
  right: 3.14vw;
  bottom: 1.69vw;
  font-family: PingFangSC-Regular;
  font-size: 2.9vw;
  color: #b8b8b8;
  letter-spacing: 0;
  line-height: 3.38vw;
  font-weight: 400;
}
.question-desc-popup .question-desc-popup-box .textarea-container .words-number .number {
  color: #1f1f1f;
}
.question-desc-popup .question-desc-popup-box .watch-example {
  padding-top: 2.42vw;
  font-family: PingFangSC-Regular;
  font-size: 3.62vw;
  color: #336cff;
  line-height: 3.62vw;
  font-weight: 400;
  text-align: right;
}
.question-desc-popup .question-desc-popup-box .watch-example-for-android {
  padding-bottom: 7.42vw;
}
.experthome-popup {
  height: 70vh;
  display: flex;
  flex-direction: column;
}
.experthome-popup .experthome-popup-title {
  height: 67px;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 19px;
  color: #1f1f1f;
  text-align: center;
  line-height: 67px;
  font-weight: 500;
  position: relative;
  background: url('https://law-smartapp.cdn.bcebos.com/bg-question.png') no-repeat top center;
  background-size: cover;
}
.experthome-popup .experthome-popup-title-nobg {
  background: #fff;
}
.experthome-popup .experthome-popup-close {
  position: absolute;
  right: 17px;
  top: 0;
  font-size: 19px;
  color: #999;
}
.experthome-popup .question-tip-content {
  height: 0;
  flex: 1;
  overflow-y: auto;
  padding: 20px 17px 0;
  box-sizing: border-box;
  position: relative;
}
.experthome-popup .experthome-popup-bottom {
  height: 43px;
  display: flex;
  align-items: flex-end;
  border-top: 1px solid #eee;
  margin: 0 0 31px;
  justify-content: center;
}
.experthome-popup .experthome-popup-bottom .experthome-popup-bottom-pic {
  width: 32px;
  height: 15px;
}
.experthome-popup .experthome-popup-bottom .experthome-popup-bottom-line {
  width: 1px;
  height: 14px;
  background: #ddd;
  border-radius: 8px;
  margin: 0 11px;
}
.experthome-popup .experthome-popup-bottom .experthome-popup-bottom-text {
  height: 15px;
  line-height: 15px;
  color: #858585;
}

</style>
